import React from "react";
import styles from "./home.module.css";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaSortAmountDown } from "react-icons/fa";
import Page from "../../Component/Pagination/Page";
import Header from "../../Component/Header/Header";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { IoIosAdd } from "react-icons/io";
import { CiUser, CiLocationOn, CiCalendarDate } from "react-icons/ci";
import { Helmet } from "react-helmet";
import { useEffect, useState } from "react";
import { GET_RESEARCHES } from "../../APIs/BaseUrl";
import Moment from "react-moment";
import Notification from "../../Component/Notification/Notification";
import { useAuth } from "../../Context/AuthContext";

const Home = () => {
  const navigate = useNavigate();

  const {toggleNotification} = useAuth();

  const [researches, setResearches] = useState([]);
  // eslint-disable-next-line
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  // eslint-disable-next-line
  const [limit, setLimit] = useState(10);

  const [pagination, setPagination] = useState({
    totalDocs: 0,
    limit: limit,
    totalPages: 1,
    page: 1,
  });

  useEffect(() => {
    const fetchResearches = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${GET_RESEARCHES}?page=${page}&limit=${limit}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch researches");
        }
        const data = await response.json();
        setResearches(data?.data?.docs || []);

        setPagination({
          totalDocs: data?.data?.totalDocs,
          limit: data?.data?.limit,
          totalPages: data?.data?.totalPages,
          page: data?.data?.page,
        });
      } catch (err) {
        setError(err.message);
      }
    };

    fetchResearches();
  }, [page, limit]);

  return (
    <React.Fragment>
      <div className="right-aside">
        <Helmet>Home</Helmet>
        <Row className="g-0">
          <Col 
            xl={!toggleNotification ? 12 : 8} 
            lg={!toggleNotification ? 12 : 8}
            md={!toggleNotification ? 12 : 12} 
            sm={12} 
            xs={12}
          >
            <Header />

            <div className={styles.head_sec}>
              <div className={styles.header_content}>
                <h6>My Researches</h6>
                <input 
                  type="text" 
                  placeholder="Search" 
                  className={styles.search_input}
                />
              </div>
              
              <div className={styles.btn_section}>
                <div className={styles.filter_sort_section}>
                  <button className={styles.filter_btn}>Filter</button>
                  <div className={styles.sort}>
                    <FaSortAmountDown />
                  </div>
                </div>
                <button
                  className={styles.add_btn}
                  onClick={() => navigate(`/research/create`)}
                >
                  <IoIosAdd size={20} /> 
                  <span className={styles.btn_text}>Add new Research</span>
                </button>
              </div>

              <div className={styles.research_list}>
                {researches.map((research) => (
                  <div
                    key={research?.id}
                    className={styles.research_card}
                  >
                    <div className={styles.card_content}>
                      <div className={styles.company_info}>
                        <img
                          src={research?.company?.profileUrl}
                          alt={research?.company?.company}
                          className={styles?.company_logo}
                        />
                        <div className={styles.research_details}>
                          <h6 className={styles.research_title}>{research?.research_name}</h6>
                          <div className={styles.research_meta}>
                            <div className={styles.meta_item}>
                              <CiUser size={16} /> 
                              <span>{research?.applications} Applies</span>
                            </div>
                            <div className={styles.meta_item}>
                              <CiLocationOn size={16} /> 
                              <span>{research?.location}</span>
                            </div>
                            <div className={styles.meta_item}>
                              <CiCalendarDate size={16} /> 
                              <span>Posted <Moment fromNow>{research?.createdAt}</Moment></span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className={styles.card_actions}>
                        <button 
                          className={styles.applies_btn}
                          onClick={() => navigate(`/applications?researchId=${research?.id}`)}
                        >
                          <CiUser size={16} /> 
                          <span>{research.applies} Applies</span>
                        </button>
                        <HiOutlineDotsVertical 
                          onClick={() => navigate(`/research/edit/${research?.id}`)} 
                          size={22} 
                          className={styles.menu_icon}
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className={styles.pagination_wrapper}>
                <Page {...pagination} onPageChange={setPage} />
              </div>
            </div>
          </Col>
          {toggleNotification && (
            <Col xl={4} lg={4} md={12} sm={12} xs={12} className="p-0">
              <div className={styles.notification_wrapper}>
                <Notification />
              </div>
            </Col>
          )}
        </Row>
      </div>
    </React.Fragment>
  );
};

export default Home;
